import React from 'react';
import { motion } from 'framer-motion';
export function BonusHero() {
  return <section className="w-full py-16 md:py-24 px-6" style={{
    backgroundColor: 'var(--cream)'
  }} data-id="element-116">
      <div className="max-w-2xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-118">
          <p className="text-sm font-semibold tracking-widest uppercase mb-4" style={{
          color: 'var(--charcoal)',
          opacity: 0.6
        }} data-id="element-119">
            Mercado: USA | Español | 35+
          </p>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight mb-6" style={{
          color: 'var(--navy)'
        }} data-id="element-120">
            Recibí 3 Herramientas Valoradas En{' '}
            <span className="relative inline-block" data-id="element-121">
              $141
              <span className="absolute bottom-1 left-0 w-full h-1 rounded-full" style={{
              backgroundColor: 'var(--gold)'
            }} data-id="element-122" />
            </span>{' '}
            Completamente Gratis — Diseñadas Para Recuperar Dinero, Frenar El
            Gasto Impulsivo y Ejecutar Pagos Extra Desde Tu Primer Cobro
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="space-y-6 text-lg md:text-xl leading-relaxed" style={{
        color: 'var(--charcoal)'
      }} data-id="element-123">
          <p data-id="element-124">
            Cuando comprás <strong data-id="element-125">"Reset de Deudas en 14 Días (USA)"</strong>{' '}
            hoy, no solo recibís el sistema principal.
          </p>
          <p data-id="element-126">
            Recibís 3 herramientas adicionales —{' '}
            <span className="font-bold" style={{
            color: 'var(--gold)'
          }} data-id="element-127">
              completamente gratis
            </span>{' '}
            — diseñadas para atacar los 3 puntos exactos donde la mayoría de
            personas pierde dinero sin darse cuenta:
          </p>
          <ul className="space-y-4 my-8 pl-4 border-l-2" style={{
          borderColor: 'var(--gold)'
        }} data-id="element-128">
            <li className="pl-4" data-id="element-129">
              Las fugas invisibles que se cobran solas cada mes.
            </li>
            <li className="pl-4" data-id="element-130">
              El impulso que gana exactamente cuando más estás vulnerable.
            </li>
            <li className="pl-4" data-id="element-131">
              La intención de pagar extra que nunca se convierte en acción real.
            </li>
          </ul>
          <p data-id="element-132">
            Cada bono resuelve uno de esos tres problemas. Hoy. Con pasos
            específicos, plantillas listas y herramientas que podés usar en
            menos de 30 minutos.
          </p>
          <p className="font-medium" style={{
          color: 'var(--navy)'
        }} data-id="element-133">
            Acá está todo lo que recibís gratis.
          </p>
        </motion.div>
      </div>
    </section>;
}